import { render } from "./SectionWelcomeBottom.vue?vue&type=template&id=06d4ba98&scoped=true"
import script from "./SectionWelcomeBottom.vue?vue&type=script&lang=js"
export * from "./SectionWelcomeBottom.vue?vue&type=script&lang=js"

import "./SectionWelcomeBottom.vue?vue&type=style&index=0&id=06d4ba98&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06d4ba98"]])

export default __exports__